import { Button, Card, CardBody, CardFooter, CardHeader } from "reactstrap";
import avatar2 from "../../../assets/images/users/multi-user.jpg";
import gambar from "../../../assets/images/auth-one-bg.jpg";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import CardFile from "../card-file/CardFile";
import CarouselAttachment from "../card-carousel";

const ShowBroadcast = (props) => {
  const processAttachment = (data, type) => {
    let attachment_ = [];

    if (data != null && data.length > 0) {
      data.map((data) => data.type === type && attachment_.push(data));
    }

    return attachment_;
  };

  return (
    <Card
      style={{
        borderBottom: "none",
        boxShadow: "none",
        margin: 0,
      }}
    >
      <CardHeader
        className="align-items-center d-flex"
        style={{
          borderBottom: "none",
          boxShadow: "none",
        }}
      >
        {props.data.option != "whatsapp" ? (
          <div
            style={{
              width: "40px",
              height: "40px",
              color: "white",
              borderRadius: "50%",
            }}
            className="bg-primary d-flex justify-content-center align-items-center me-3"
          >
            <span className="mdi mdi-access-point fs-22"></span>
          </div>
        ) : (
          <svg
            width="40"
            height="40"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="me-3"
          >
            <rect width="56" height="56" rx="28" fill="#D0D8D2" />
            <path
              d="M27.7938 14.8988C30.99 14.8461 34.0954 15.9616 36.5275 18.036C38.9596 20.1104 40.551 23.0011 41.0031 26.1655C41.4553 29.3299 40.737 32.5506 38.9832 35.2231C37.2294 37.8956 34.5606 39.8361 31.4776 40.6806C28.536 41.4864 25.4102 41.2415 22.6359 39.9963L16.4178 41.1045C15.9417 41.1893 15.4576 41.0055 15.1577 40.6261C14.8579 40.2467 14.791 39.7331 14.9836 39.2896L16.8657 34.9551C15.3172 32.4661 14.6426 29.5229 14.9629 26.5946C15.3106 23.417 16.8059 20.4755 19.1683 18.3221C21.5306 16.1687 24.5977 14.9514 27.7938 14.8988Z"
              fill="#44624D"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.3266 22.6704C23.6958 22.3012 24.1966 22.0938 24.7188 22.0938C25.2409 22.0938 25.7417 22.3012 26.1109 22.6704C26.4801 23.0396 26.6875 23.5404 26.6875 24.0625V25.375C26.6875 25.8971 26.4801 26.3979 26.1109 26.7671C25.9781 26.8999 25.8283 27.0117 25.6667 27.1005C25.9245 27.8413 26.3475 28.5221 26.9127 29.0873C27.4779 29.6525 28.1587 30.0755 28.8995 30.3333C28.9883 30.1717 29.1001 30.0219 29.2329 29.8891C29.6021 29.5199 30.1029 29.3125 30.625 29.3125H31.9375C32.4596 29.3125 32.9604 29.5199 33.3296 29.8891C33.6988 30.2583 33.9062 30.7591 33.9062 31.2812C33.9062 31.8034 33.6988 32.3042 33.3296 32.6734C32.9604 33.0426 32.4596 33.25 31.9375 33.25H30.625C28.5364 33.25 26.5334 32.4203 25.0565 30.9435C23.5797 29.4666 22.75 27.4636 22.75 25.375V24.0625C22.75 23.5404 22.9574 23.0396 23.3266 22.6704Z"
              fill="#D0D8D2"
            />
          </svg>
        )}
        <div>
          <h4 className="card-title mb-0 flex-grow-1">Pesan Siaran!</h4>
          <p className="m-auto">
            {moment(props.data.time).locale("id").format("D MMMM YYYY")}
          </p>
        </div>
      </CardHeader>
      <CardBody>
        <h5 className="mt-3 fw-bold">{props.data.name}</h5>

        {props.dataSelected != null ? (
          props.dataSelected.length > 0 ? (
            props.dataSelected.map((data) => (
              <>
                <p className="mt-3">{data.content}</p>

                {/* image */}
                {data.attachment != null && data.attachment.length > 0 ? (
                  <CarouselAttachment
                    images={processAttachment(data.attachment, "Image").map(
                      (data) => ({ attachment: data.content, Name: data.name })
                    )}
                  />
                ) : null}

                {/* video */}
                {/* {data.attachment != null && data.attachment.length > 0 ? (
                  <CardVideo
                    item={processAttachment(data.attachment, "Video").map(
                      (data) => ({ attachment: data.content, Name: data.name })
                    )}
                  />
                ) : null} */}

                {/* audio */}
                {/* {data.attachment != null && data.attachment.length > 0 ? (
                  <CardAudio
                    item={processAttachment(data.attachment, "Audio").map(
                      (data) => ({ attachment: data.content, Name: data.name })
                    )}
                  />
                ) : null} */}
                {/* document */}
                {data.attachment != null && data.attachment.length > 0 ? (
                  <CardFile
                    item={processAttachment(data.attachment, "Document").map(
                      (data) => ({ attachment: data.content, Name: data.name })
                    )}
                  />
                ) : null}
              </>
            ))
          ) : null
        ) : (
          <Skeleton height={20} count={1} />
        )}
        <Button
          style={{ float: "right" }}
          color="primary"
          onClick={() => props.toggle()}
        >
          Ok
        </Button>
      </CardBody>
    </Card>
  );
};

export default ShowBroadcast;
